module.exports = __webpack_public_path__ + "static/media/thumbnail.04b7108c.jpg";